module.exports = __webpack_public_path__ + "img/logo.b6d63be7.svg";